import React from 'react';

const searchicon = () => {
  return (
    <svg version="1.1" baseProfile="basic"
      xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16px" height="16px"
      viewBox="0 0 32 32" space="preserve">
      <path transform="matrix(0.032,0,0,0.032,0,0)" stroke="none" style={{ fill: "#0098db" }} d="M 1000 934 L 793 727 C 857 648 892 549 892 446 C 892 327 846 215 762 130 C 677 46 565 0 446 0 C 327 0 215 46 130 130 C 46 215 0 327 0 446 C 0 565 46 677 130 762 C 215 846 327 892 446 892 C 550 892 648 857 727 793 L 934 1000 L 1000 934 z M 160 732 C 84 656 41 554 41 446 C 41 338 84 236 160 160 C 236 84 338 41 446 41 C 554 41 656 84 732 160 C 808 236 850 338 850 446 C 850 554 808 656 732 732 C 656 808 554 850 446 850 C 338 850 236 808 160 732 z" />
    </svg>
  );
};

export default searchicon;


// WEBPACK FOOTER //
// ./src/searchicon.jsx